export default "__VITE_ASSET__b8a25aa0__"